import { ESaleStatus } from '../../types/filters';

interface ISaleStatus {
  label: string;
  value: ESaleStatus;
}

export const SALE_STATUSES: ISaleStatus[] = [
  { label: 'Открыты', value: ESaleStatus.Opened },
  { label: 'Ожидание', value: ESaleStatus.Pending },
  { label: 'Завершены', value: ESaleStatus.Closed },
];
